export function reducer(state, action) {
  switch (action.type) {
    case 'SET_MIXED_CONTENT':
      return {
        ...state,
        mixedContent: action.payload,
      };

    case 'SET_IDS':
      return {
        ...state,
        ids: action.payload ?? [],
      };
    case 'ADD':
      return {
        mixedContent: [...state?.mixedContent, action.payload],
        ids: state.ids.concat(action.payload.id),
      };
    case 'REMOVE': {
      const newIds = state.ids.filter((item) => item !== action.payload.id);
      const newMixedContent = state.mixedContent.filter(
        (item) => item.id !== action.payload.id
      );

      return {
        mixedContent: newMixedContent,
        ids: newIds,
      };
    }
    default:
      throw new Error(`Unresolved action type "${action.type}"`);
  }
}
